var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.264H42.75M2.25 29.764H42.75M15.75 16.264V43.264M29.25 16.264V43.264M6.75 2.76398H38.25C40.7353 2.76398 42.75 4.7787 42.75 7.26398V38.764C42.75 41.2493 40.7353 43.264 38.25 43.264H6.75C4.26472 43.264 2.25 41.2493 2.25 38.764V7.26398C2.25 4.7787 4.26472 2.76398 6.75 2.76398Z",
    stroke: "#08387C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.da54f32608b0ed71a8d4e4cfe5040dae.svg";
export { ForwardRef as ReactComponent };